import React from 'react'
import { getUserInitials } from '../../utils/userInitials'

const AccountIdentityStrip: React.FC<{ name: string; email: string }> = ({
  name,
  email,
}) => (
  <div className="flex items-center gap-3 border border-rule bg-paper-200/40 rounded-sm px-3 py-2">
    <div
      aria-hidden
      className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-ink text-paper font-serif text-sm"
    >
      {getUserInitials(name)}
    </div>
    <div className="min-w-0">
      <p className="font-serif text-base text-ink truncate">{name}</p>
      <p className="font-mono text-xs text-ink-500 truncate">{email}</p>
    </div>
  </div>
)

export default AccountIdentityStrip
